import React, { useEffect, useState } from 'react';
import { getStats } from '../services/api';

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const load = () => getStats().then(setStats).catch(console.error);
    load();
    const id = setInterval(load, 5000);
    return () => clearInterval(id);
  }, []);

  if (!stats) return null;

  const total = Object.values(stats).reduce((a, b) => a + b, 0);

  return (
    <div className="stats-strip">
      <div className="stat-pill total">
        <span className="stat-pill-value">{total}</span>
        <span className="stat-pill-label">Total</span>
      </div>
      <div className="stat-pill received">
        <span className="stat-pill-value">{stats.RECEIVED || 0}</span>
        <span className="stat-pill-label">Received</span>
      </div>
      <div className="stat-pill processing">
        <span className="stat-pill-value">{stats.PROCESSING || 0}</span>
        <span className="stat-pill-label">Processing</span>
      </div>
      <div className="stat-pill completed">
        <span className="stat-pill-value">{stats.COMPLETED || 0}</span>
        <span className="stat-pill-label">Completed</span>
      </div>
      <div className="stat-pill failed">
        <span className="stat-pill-value">{stats.FAILED || 0}</span>
        <span className="stat-pill-label">Failed</span>
      </div>
    </div>
  );
}
